import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["interactive"]

  navigate(event) {
    // Don't navigate if clicking on an interactive element
    if (this.isInteractiveElement(event.target)) {
      return
    }

    // Check if click is inside an interactive target
    for (const interactive of this.interactiveTargets) {
      if (interactive.contains(event.target)) {
        return
      }
    }

    // Navigate to the post page with full page load
    Turbo.visit(this.urlValue)
  }

  isInteractiveElement(element) {
    // Check the element and its parents for interactive elements
    let current = element
    while (current && current !== this.element) {
      const tagName = current.tagName?.toLowerCase()
      if (
        tagName === 'a' ||
        tagName === 'button' ||
        tagName === 'input' ||
        tagName === 'select' ||
        tagName === 'textarea' ||
        current.getAttribute('role') === 'button' ||
        current.hasAttribute('data-action')
      ) {
        return true
      }
      current = current.parentElement
    }
    return false
  }
}
